var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.5 17.5",
    style: {
      enableBackground: "new 0 0 17.5 17.5"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.configuration-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "configuration-svg",
    d: "M10,1.7c-0.1-0.5-0.5-1-1.1-1H8.6c-0.6,0-1,0.4-1.1,1L7.4,2.4C7.4,2.8,7,3.2,6.6,3.4c-0.1,0-0.1,0.1-0.2,0.1 C6,3.6,5.5,3.6,5.2,3.3L4.8,3.1C4.4,2.8,3.8,2.8,3.4,3.2L3.2,3.4c-0.4,0.4-0.4,1-0.1,1.4l0.3,0.3C3.6,5.5,3.6,6,3.4,6.4 c0,0.1-0.1,0.1-0.1,0.2C3.2,7,2.8,7.4,2.4,7.4L1.7,7.5c-0.5,0.1-1,0.5-1,1.1v0.3c0,0.6,0.4,1,1,1.1l0.7,0.1c0.4,0.1,0.8,0.4,1,0.8 c0,0.1,0.1,0.1,0.1,0.2c0.2,0.4,0.2,0.9-0.1,1.3l-0.3,0.3c-0.3,0.4-0.3,1.1,0.1,1.4l0.2,0.2c0.4,0.4,1,0.4,1.4,0.1l0.3-0.3 c0.4-0.3,0.8-0.3,1.3-0.1c0.1,0,0.1,0.1,0.2,0.1c0.4,0.2,0.7,0.5,0.8,1l0.1,0.7c0.1,0.5,0.5,1,1.1,1h0.3c0.6,0,1-0.4,1.1-1l0.1-0.7 c0.1-0.4,0.4-0.8,0.8-1c0.1,0,0.1-0.1,0.2-0.1c0.4-0.2,0.9-0.2,1.3,0.1l0.3,0.3c0.4,0.3,1.1,0.3,1.4-0.1l0.2-0.2 c0.4-0.4,0.4-1,0.1-1.4l-0.3-0.3c-0.3-0.4-0.3-0.8-0.1-1.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.5-0.7,1-0.8l0.7-0.1 c0.5-0.1,1-0.5,1-1.1V8.6c0-0.6-0.4-1-1-1.1l-0.7-0.1c-0.4-0.1-0.8-0.4-1-0.8c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.4-0.2-0.9,0.1-1.3 l0.3-0.3c0.3-0.4,0.3-1.1-0.1-1.4l-0.2-0.2c-0.4-0.4-1-0.4-1.4-0.1l-0.3,0.3c-0.4,0.3-0.8,0.3-1.3,0.1c-0.1,0-0.1-0.1-0.2-0.1 c-0.4-0.2-0.7-0.5-0.8-1L10,1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "configuration-svg",
    d: "M10.1,8.8c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4C7.4,8,8,7.4,8.7,7.4C9.5,7.4,10.1,8,10.1,8.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.db1c75da3cf24c9512129a6346747603.svg";
export { ForwardRef as ReactComponent };